export default __webpack_public_path__ + "static/media/Group1857link.4cdbba76.svg";